import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { DesktopActivityPermissions } from './permissions'

async function lazyGuardedRoute<T extends Record<string, unknown>>(
  importPage: () => Promise<T>,
  exportName: keyof T & string,
  perm: string,
  administratorBypass = true,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const page = mod[exportName]
  if (typeof page !== 'function') {
    throw new Error(`Missing ${exportName}`)
  }
  return {
    Component: createPermissionGuardedPage(perm, page as ComponentType, { administratorBypass }),
  }
}

export const desktopActivityRoutes: RouteObject[] = [
  {
    path: 'admin/desktop-activity',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/desktop-activity-page'),
        'DesktopActivityPage',
        DesktopActivityPermissions.review,
      ),
  },
  {
    path: 'account/desktop-activity',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/my-desktop-activity-page'),
        'MyDesktopActivityPage',
        DesktopActivityPermissions.record,
        false,
      ),
  },
]
